<template>
    <v-dialog v-model="dialog" scrollable max-width="600px" hide-overlay>
        <template v-slot:activator="{ on }">
            <v-btn color="secondary" small icon v-on="on">
                <v-tooltip bottom color="primary">
                    <template v-slot:activator="{ on }">
                        <v-icon small v-on="on">mdi-pencil</v-icon>
                    </template>
                    <span>edit needs</span>
                </v-tooltip>
            </v-btn>
        </template>
        <v-card v-if="!loading">
            <v-card-title class="subtitle-2 pt-6 text-pre-wrap">
                Advanced features new needs values for <span class="secondary--text">{{ af.segment.name }}</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="black--text">
                <v-container grid-list-md>
                    <v-form v-model="valid" ref="form" validation>
                        <v-row justify="center">
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Positioning tracker"
                                    v-model.number="positioning_tracker" 
                                    name="positioning_tracker"
                                    :rules="[rules.required]" type="text"
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Power bank" v-model.number="power_bank"
                                    name="power_bank" :rules="[rules.required]" type="text"
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Missed items warning"
                                    v-model.number="missed_items_warning" name="items_warning" :rules="[rules.required]"
                                    type="text" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field dense color="primary" label="Danger alarm" v-model.number="danger_alarm"
                                        name="danger_alarm" :rules="[rules.required]" type="text"
                                        @change="onceMore()">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field dense color="primary" label="Fridge camera" v-model.number="fridge_camera"
                                        name="fridge_camera" :rules="[rules.required]" type="text"
                                        @change="onceMore()">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field dense color="primary" label="Loss insurance" v-model.number="loss_insurance"
                                        name="loss_insurance" :rules="[rules.required]" type="text"
                                        @change="onceMore()">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field dense color="primary" label="Environment friendly utilization"
                                        v-model.number="friendly_utilization" name="friendly_utilization"
                                        :rules="[rules.required]" type="text"
                                        @change="onceMore()">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field dense color="primary" label="Charity profit sharing"
                                        v-model.number="profit_sharing" name="profit_sharing" :rules="[rules.required]"
                                        type="text"
                                        @change="onceMore()">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field dense color="primary" label="Individual pictures"
                                        v-model.number="individual_pictures"
                                        name="individual_pictures"
                                        :rules="[rules.required]" type="text"
                                        @change="onceMore()">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                    <v-row justify="center" class="error--text">{{ error }}</v-row>
                    <v-row justify="center" class="subtitle-2">{{ message }}</v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text class="text-capitalize"
                        :disabled="!haveBeenChanged || Boolean(error)" 
                        @click="save">
                        Save
                    </v-btn>
                    <v-btn color="primary" text class="text-capitalize" 
                        @click="closeDialog">
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
</template>
<script>
export default {
    name: 'Edit_HiddenNeeds',
    props: ['af'],
    data() {
        return {
            dialog: false,
            error: '',
            message: '',
            valid: false,
            haveBeenChanged: false,
            //props
            positioning_tracker: this.af.positioning_need,
            power_bank: this.af.power_bank_need,
            missed_items_warning: this.af.missed_items_warning_need,
            danger_alarm: this.af.danger_alarm_need,
            fridge_camera: this.af.fridge_camera_need,
            loss_insurance: this.af.loss_insurance_need,
            friendly_utilization: this.af.friendly_utilization_need,
            profit_sharing: this.af.profit_sharing_need,
            individual_pictures: this.af.individual_pictures_need,
            rules: {
                required: value => !!value || 'required field',
                number: v => /^[+]?[0-9]/.test(v) || 'it\'s expected a number',
            }
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading;
        }

    },
    methods: {
        closeDialog() {
            this.dialog = false
            this.message = ''
            this.error = ''
            this.haveBeenChanged = false

            this.positioning_tracker = this.af.positioning_need;
            this.power_bank = this.af.power_bank_need
            this.missed_items_warning = this.af.missed_items_warning_need
            this.danger_alarm = this.af.danger_alarm_need
            this.fridge_camera = this.af.fridge_camera_need
            this.loss_insurance = this.af.loss_insurance_need
            this.friendly_utilization = this.af.friendly_utilization_need
            this.profit_sharing = this.af.profit_sharing_need
            this.individual_pictures = this.af.individual_pictures_need
        },
        onceMore() {
            this.error = ''
            this.haveBeenChanged = true;
        },
        async save() {

            if (this.$refs.form.validate()) {
                const hidden_need = {
                    id: this.af.id,
                    gameId: this.af.gameId,
                    round: this.af.round,
                    segmentId: this.af.segmentId,
                    segment: this.af.segment,
                    positioning_need: this.positioning_tracker,
                    power_bank_need: this.power_bank,
                    missed_items_warning_need: this.missed_items_warning,
                    danger_alarm_need: this.danger_alarm,
                    fridge_camera_need: this.fridge_camera,
                    loss_insurance_need: this.loss_insurance,
                    friendly_utilization_need: this.friendly_utilization,
                    profit_sharing_need: this.profit_sharing,
                    individual_pictures_need: this.individual_pictures,
                }
                try {
                    await this.$store.dispatch('editAF', hidden_need);
                    this.closeDialog();
                }
                catch (error) {
                    this.error = error.message
                }
            }
        },
    },
}
</script>
